import * as ElectronicRegistration from './electronicRegistration';
import * as ElectronicRegistrationProcess from './electronicRegistrationProcess';
import * as KioskUsers from './users';

export const ElectronicRegistrationApi = ElectronicRegistration;
export const ElectronicRegistrationProcessApi = ElectronicRegistrationProcess;
export const KioskUsersApi = KioskUsers;
